<template>
	<div class="app">
		<template v-if="shop && shop.id">
			<keep-alive>
				<router-view  :key="$route.fullPath"  v-if="$route.meta.keepAlive"></router-view>
			</keep-alive>
			<router-view  :key="$route.fullPath"  v-if="!$route.meta.keepAlive"></router-view>
			<v-tab-bar  v-if="$route.meta.isshowtabbar" ref='bar'></v-tab-bar>
		</template>
		<template v-else>
			Invalid shop - 非法门店
		</template>
	</div>
</template>

<script>
import { mapState, mapMutations, mapActions } from 'vuex'
import tabBar from './components/common/Tabbar'
import { cartQuantity } from './api/cart'
import { userProfileGet } from '@/api/user';
import { getCid } from './api/access'
import { Toast,Indicator } from 'mint-ui'
import wx from 'weixin-js-sdk'
import { ENUM } from '@/const/enum';

export default {
	name: 'app',
	computed: {
		...mapState({
			state_token: state => state.auth.token,
			config: state => state.config.config,
			user: state => state.auth.user,
			isOnline: state => state.auth.isOnline,
			cachedViews: state => state.tagsView.cachedViews,
			shoplist:state => state.auth.shoplist,
      shop:state => state.auth.shop,
		})
	},
	created: function() {
		this.saveAuthInfo()	
		if(this.$cookie.get("cid") == undefined ||  this.$cookie.get("cid") == null ){
				console.log("App.vue/created：cookie中没有cid，开始获取cid")
				this.getTheCid()
		}else{
			if(this.shop && this.shop.id){
				let urlShopId =  this.getQueryVariable('shopId')
				console.log("App.vue/created：url中的ShopId ："+urlShopId)

				if(urlShopId && (urlShopId != this.shop.id)){
					console.log("App.vue/created/urlShopId!=this.shop.id")
					if(this.shoplist && this.shoplist.length>0){
						console.log("【App.vue】created/shoplist.length : "+this.shoplist.length)
							let index = this.shoplist.findIndex(item=>item.id ==urlShopId)
							if(index > -1 && urlShopId != (this.shop || {}).id){
								console.log("App.vue/created：切换门店中...")
								Toast("切换门店中...");
								this.clearCategoryItems()
								this.saveShop(this.shoplist[index] || {})
								window.location.replace(window.location.href)
							}
						console.log("App.vue/created/没切换门店")
					}else{
						console.log('App.vue/created：URL中传递了新shopId，但没有shoplist')
						this.getCity()
					}
				}else {
					console.log("App.vue/created：有this.shop，但没有urlShopId")
				}
			}else{
				console.log('created/没有shop，开始getCity')
				this.getCity()
			}
		}
		let name = this.$route.name
		if (name){
			this.changeTabBar(name);
		}
	},
	mounted(){
		// if(this.isOnline && (this.user == undefined  || this.user== null)){
		// 	this.timer = setTimeout(()=>{
		// 		userProfileGet().then( response => {
		// 				if (response && response.user) {
		// 					this.saveUser(response);
		// 				}
		// 			},error =>  console.error(error)
		// 		)
		// 	},2000)
		// }
		if(this.isOnline){
			if (this.user == undefined  || this.user== null) {
				userProfileGet().then( response => {
						if (response && response.user) {
							this.saveUser(response);
							this.getCartNumber();
						}
					},error =>  console.error(error)
				)				
			}else {
				this.getCartNumber();
			}
		}
	},
	watch: {
		$route(to, from) {
			this.resetStates();
			this.changeTabBar(to.name);
		}
	},
	beforeRouteLeave (to, from, next) {
		if (this.config) {
			let wechat = this.config['wechat.web'] || {};
			this.shareConfig(wechat)
		}
	},
  beforeDestroy() {
    if (this.timer){clearTimeout(this.timer);}
  },
	methods: {
		...mapMutations({
			saveUser: 'saveUser',
			saveToken: 'saveToken',
			saveShop: 'saveShop',
			clearShop: 'clearShop',
			changeTabBar: 'changeTabBar',
			setCartNumber: 'setCartNumber',
			clearCategoryItems: 'clearCategoryItems'
		}),
		...mapActions({
			fetchConfig: 'fetchConfig',
			fetchHomeAddress:'fetchHomeAddress',
			resetStates: 'resetStates',
			addVisitedViews:'addVisitedViews',
		}),
		getQueryVariable(variable){
				let query = window.location.search.substring(1);
				let vars = query.split("&");
				for (let i=0;i<vars.length;i++) {
						let pair = vars[i].split("=");
						if(pair[0] == variable){return pair[1];}
				}
				let value = this.$route.query[variable]
				return value || false;
		},
		getTheCid(){
			getCid().then(resp=>{
				if(resp.error_code == 0){
						this.$cookie.set("cid",resp.cid)
						this.$cookie.set("subscription_name",resp.Subscription_name)
						this.getCity()
					}
				}).catch(err=>{console.error(err)})
		},
		sendCoordinate(longitude, latitude){
				let type = null
				if(window.android){
					type = 'android'
				}else if(typeof window.webkit == 'object'){
					type = 'ios'
				}else if(isIphone()){
					type = 'ios'
				}else if(this.wxApi.isweixin()){
					type = 'weixin'
				}else {
					type = 'h5'
				}
				this.fetchHomeAddress({lng: longitude, lat: latitude, type: type }).then(response => {
						if(response && response.result){
							window.address  =  response.result
						}
					},error => {this.message = '附近暂无门店!'}
				);
		},
		generateRoute(){
			if (this.$route.name) {
				return this.$route
			}
			return false
		},
		addView(){
			const route = this.generateRoute()
			if (!route) {
				return false
			}
			this.addVisitedViews(route)
		},
		getCartNumber() {
			console.log("【App.vue】getCartNumber/同步购物车数量")
			cartQuantity().then( res => {
				if (res)  this.setCartNumber(res.quantity);
			})
		},
		reload(){
			this.clearShop()
			sessionStorage.clear()
			localStorage.clear()
			window.location.reload()
		},
		saveAuthInfo() {
			let location = window.location
			let references = this.utils.getUrlKey(location.href, 'u')		
			if (references)  this.$cookie.set('r', references)
			let token = this.utils.getUrlKey(location.href, 'token')		
			if (token) {
				this.$cookie.set('t', token)
				this.saveToken({ 'token': token })	
		console.log("【App.vue】saveAuthInfo/保存URL里的token:"+this.state_token)
			}
			if(this.$cookie.get("t")){
				this.saveToken({ 'token': this.$cookie.get("t") })
				console.log("【App.vue】saveAuthInfo/保存的cookie里的token:"+token)
			}
		},
		getCity(){
			console.log('【App.vue】getCity!')
      if(this.wxApi.isweixin()){
				console.log("App.vue/getCity：is weixin")
				let openid = this.$cookie.get('o') || null;
				if(this.config  &&  this.config['wechat.web']){
						let wechat = this.config['wechat.web'] || {};
						console.log("App.vue/getCity：config of wechat.web="+JSON.stringify(wechat))
            wx.config({
            	debug: false, // 开启调试模式
							appId:  wechat.app_id, // 必填，公众号的唯一标识
							timestamp: wechat.timestamp, // 必填，生成签名的时间戳
							nonceStr: wechat.nonceStr, // 必填，生成签名的随机串
							signature: wechat.signature, // 必填，签名，见附录1
							jsApiList: [
								'onMenuShareTimeline', // 获取“分享到朋友圈”按钮点击状态及自定义分享内容接口
								'onMenuShareAppMessage', // 获取“分享给朋友”按钮点击状态及自定义分享内容接口
								'onMenuShareQQ', // 获取“分享到QQ”按钮点击状态及自定义分享内容接口
								'onMenuShareWeibo', // 获取“分享到微博”按钮点击状态及自定义分享内容接口
								'getLocation',
								'updateAppMessageShareData',
								'updateTimelineShareData',
								'scanQRCode',
								'qrCode',
								'barCode',
							] // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
            });
            wx.error(function(error){
							console.error(error)
            });
            wx.ready(()=>{
              wx.getLocation({
								type: 'wgs84',	// wgs84、gcj02
                  success: (res)=>{
                    var latitude = res.latitude; // 纬度，浮点数，范围为90 ~ -90
                    var longitude = res.longitude; // 经度，浮点数，范围为180 ~ -180。
                    var speed = res.speed; // 速度，以米/每秒计
										var accuracy = res.accuracy; // 位置精度
										this.sendCoordinate(longitude, latitude)
                  },
									fail: (err) => {
										console.error(err);
										this.sendCoordinate(0,0);
									}
							});
							this.shareConfig(wechat)
						});
				}else{
					this.fetchConfig().then(response => {
						let wechat = response.config['wechat.web'] || {};
						if (Object.keys(wechat).length !== 0) {
							console.log("App.vue/getCity：config_wechat="+JSON.stringify(wechat))
							wx.config({
								debug: false, // 开启调试模式
								appId: wechat.app_id, // 必填，公众号的唯一标识
								timestamp: wechat.timestamp, // 必填，生成签名的时间戳
								nonceStr: wechat.nonceStr, // 必填，生成签名的随机串
								signature: wechat.signature, // 必填，签名，见附录1
								jsApiList: [
									'onMenuShareTimeline', // 获取“分享到朋友圈”按钮点击状态及自定义分享内容接口
									'onMenuShareAppMessage', // 获取“分享给朋友”按钮点击状态及自定义分享内容接口
									'onMenuShareQQ', // 获取“分享到QQ”按钮点击状态及自定义分享内容接口
									'onMenuShareWeibo', // 获取“分享到微博”按钮点击状态及自定义分享内容接口
									'getLocation',
									'updateAppMessageShareData',
									'updateTimelineShareData',
									'scanQRCode',
									'qrCode',
									'barCode',
								] // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
							});
							wx.error(function(error){
								console.error(error)
								this.h5location()
							});
							console.log("开始定位！")
							wx.ready(()=>{
								console.log("ready开始！")
								wx.getLocation({
									type: 'wgs84',	// wgs84、gcj02
									timeout: 10000, // 设置为10秒
									success: (res)=>{
										var latitude = res.latitude; // 纬度，浮点数，范围为90 ~ -90
										var longitude = res.longitude; // 经度，浮点数，范围为180 ~ -180。
										var speed = res.speed; // 速度，以米/每秒计
										var accuracy = res.accuracy; // 位置精度
										console.log("sendCoordinate / 开始调用接口");
										this.sendCoordinate(longitude, latitude)
									},
									fail: (err) => {
										console.error(err);
										this.sendCoordinate(0,0);
									}
								});
								this.shareConfig(wechat)
							});							
						}else {
							console.log("App.vue/getCity/fetchConfig：no wechat from response!")
						}

          }).catch(err=>{
						console.error(err)
					});
				}
      }else if(window.android){
				console.log("App.vue/getCity：is android")
        // 调用原生app 定位方法
        if(typeof window.android.acquireCoordinate == 'function'){
          window.android.acquireCoordinate();;
        }else{  
          this.h5location()
        }
      }else if(isIphone()){
				console.log("App.vue/getCity：isIphone")
        if(typeof window.webkit == 'object'){
          window.webkit.messageHandlers.acquireCoordinate.postMessage(null);
        }else{
					this.h5location()
        }
      }else{
				console.log("App.vue/getCity：is H5")
        this.h5location()
      }
		},
		h5location(){
        var _that = this
        var geolocation = new BMap.Geolocation();
        geolocation.getCurrentPosition(function(r){
          if (this.getStatus() == BMAP_STATUS_SUCCESS) {
            if(r.latitude==null){
              Toast("您已拒绝地理位置授权");
              return;
            }else{
							let rlt = _that.bdTogcj(r.point.lat, r.point.lng)
              this.sendCoordinate(rlt[1], rlt[0])
            }
          }
        })
		},
		bdTogcj(lat, lng){
		　　let x_pi = 3.14159265358979324 * 3000.0 / 180.0;
		　　let x = lng - 0.0065;
		　　let y = lat - 0.006;
		　　let z = Math.sqrt(x * x + y * y) - 0.00002 * Math.sin(y * x_pi);
		　　let theta = Math.atan2(y, x) - 0.000003 * Math.cos(x * x_pi);
		　　let g2_lnn = z * Math.cos(theta);
		　　let g2_lat = z * Math.sin(theta);
		　　return [g2_lat, g2_lnn]
		},
		shareConfig(wechat){
			let scope = 'snsapi_userinfo'; // 允许获取用户信息
			let cid = this.$cookie.get("cid")
			let shopId = this.shopId || ''
			let ref = encodeURIComponent(window.location.href+"&cid="+cid+"&shopId="+shopId);
			let locationRef = env.API_HOST + '/v2/ecapi.auth.web?vendor=' + ENUM.SOCIAL_VENDOR.WEIXIN + '&scope=' + scope + '&referer=' + ref +'&cid=' + cid;
			let desc ="本公众号值得分享给好友,快来打开吧"
			let imgUrl = require('./assets/image/change-icon/app-icon.png')
			this.setWechatConfig(wechat, imgUrl, desc, locationRef)
		},
		setWechatConfig(config, imgUrl, desc, link) { 
			let subscription_name = this.$cookie.get("subscription_name")  || "分享"
			this.wxApi.wxRegister(config, subscription_name, imgUrl, desc, link)
		},
	},
	components: {
		'v-tab-bar': tabBar
	}
}
</script>

<style lang="scss" scoped>
.app {
	min-height: 100%;
	width:100%;
	max-width: 100%;
	.spinner{
		position: absolute;
		left:50%;
    top:50%;
		margin-left:-14px;   //这两行代码也可以替换成
    margin-top:-14px; 
	}
	.title{
		position: absolute;
    top: 56%;
		width: 100%;
		text-align: center;
	}
}
</style>



// WEBPACK FOOTER //
// src/App.vue